import { createSlice } from '@reduxjs/toolkit';

export const userIdentities = createSlice({
  name: 'IDENTITIES',
  initialState: {}, // state comes from preloadedState in the store and overwrites

  reducers: {
    updateIdentities(state, action) {
      const { lytics, visitorId } = action.payload;
      return {
        ...state,
        ...(lytics !== undefined && { lytics }), // The lytics identifier is requested from the host page
        ...(visitorId !== undefined && { visitorId }), // The internal visitorId is generated by the form
      };
    },
    setAnuraData(state, action) {
      const { anuraData } = action.payload;
      return {
        ...state,
        ...(anuraData !== undefined && { anuraData }),
      };
    },
  },
});

const { actions, reducer } = userIdentities;

export const { updateIdentities, setAnuraData } = actions;

export default reducer;
